module.exports = __webpack_public_path__ + "static/img/news1.52965b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news1.png
// module id = 51NG
// module chunks = 0